export const texts = {
  searchPlaceholder: { de: 'Nach Ort suchen', en: 'Search for a location' }
};
